export {Footer} from './Footer'

// Re-export schemas for external use if needed
export {
  CallRequestSchema,
  FeedbackSchema,
  SubscriptionSchema,
  type CallRequestData,
  type FeedbackData,
  type SubscriptionData,
} from './footer.types'
